<app-mrp-scrolltop></app-mrp-scrolltop>
 
<!-- Main -->
<main id="main" class="wrapper">
  <article class="inner">
    <div class="content">

        <div class="row">
            <div class="col-12 col-12-medium">
                        <h1 class="visually-hidden">Michigan GOP Delegate Resources - Parliamentary Tools</h1>
                        <header><h2>Michigan</h2></header>
                        <h4><b>Delegate Resources</b></h4>

                        <p>Effectiveness begins with knowledge</p> 
                        <p>True participation in our government, or in leadership, requires both knowledge and skill. </p>

                        
                        <div class="offering-container">
                            <ul class="actions fit">
                                <li><a routerLink="/questions" class="button  fit">Common Questions</a></li>
                            </ul>  
                            <ul class="actions fit">
                                <li><a routerLink="/stateparty" class="button  fit">State Party</a></li>
                            </ul>
                            <ul class="actions fit">
                                <li><a routerLink="/delegate" class="button  fit">Delegates</a></li>
                            </ul>
                            <ul class="actions fit">
                                <li><a routerLink="/stateconvention" class="button  fit">State Convention</a></li>
                            </ul>
                            <ul class="actions fit ">
                                <li><a routerLink="/countyconvention" class="button  fit">County Convention</a></li>
                            </ul>
                            <ul class="actions fit ">
                                <li><a routerLink="/timeline" class="button  fit">Elecion Time Line</a></li>
                            </ul>
                            <ul class="actions fit ">
                                <li><a routerLink="/documents" class="button  fit">Legal Documents</a></li>
                            </ul>
                            <ul class="actions fit ">
                                <li><a routerLink="/roberts" class="button  fit">RONR for Delegates</a></li>
                            </ul>
                            <ul class="actions fit ">
                                <li><a routerLink="/tools" class="button  fit">Free Meeting Tools</a></li>
                            </ul>

                        </div>
                        <br>

                        <blockquote>"If virtue and knowledge are diffused among the People, they will never be enslav'd. This will be their great Security." 
                            <p>-Samuel Adams February 12, 1779</p>
                        </blockquote>        
            </div>
        </div>   
      
    </div>
  </article>
</main>
<app-footer></app-footer>

